import React from 'react';

export const tabcldNotificationContainerStyle: React.CSSProperties = {
    width: '510px',
    height: '300px',
    padding: '5px'
};

export const tabcldNotificationContainerTitleStyle: React.CSSProperties = {
    paddingBottom: '8px',
    fontSize: 'large'
};

export const tabcldNotificationContainerContentStyle: React.CSSProperties = {
    width: '510px',
    height: '240px',
    overflow: 'auto'
};

export const tabcldNotificationContainerCheckboxStyle: React.CSSProperties = {
    width: '510px',
    marginTop: '10px',
    display: 'flex',
};

export const tabcldNotificationContainerControlStyle: React.CSSProperties = {
    width: '510px',
    marginTop: '10px'
};

export const tabcldNotificationContainerButtonGroupStyle: React.CSSProperties = {
    alignSelf: 'flex-end'
};

export const tabcldNotificationContainerPreButtonStyle: React.CSSProperties = {
    marginLeft: '2px',
    fontSize: '12px',
    float: 'left',
    border: 'none'
};

export const tabcldNotificationContainerNextButtonStyle: React.CSSProperties = {
    marginRight: '2px',
    fontSize: '12px',
    float: 'right',
    border: 'none'
};

export const tabcldNotificationContainerCloseButtonStyle: React.CSSProperties = {
    marginRight: '2px',
    fontSize: '12px',
    float: 'right',
    border: 'none'
};

export const tabcldNotificationContainerCountStyle: React.CSSProperties = {
    display:'flex',
    justifyContent: 'flex-end'
};

export const tabcldNotificationInfoStyle: React.CSSProperties = {
    marginLeft: '5px'
};
